<div class="row">
    <div class="container-title">
        <h2>Elige el plan perfecto para tu futuro financiero</h2>
        <p class="description">Selecciona el plan que mejor se adapte a tus objetivos de inversión y comienza a construir tu patrimonio hoy mismo</p>
    </div>
</div>

<div class="row mb-5">
    @if (isMediumScreen == false) {
        <div *ngFor="let plan of planes; let i = index" class="col-lg-4" #plan >
            <div class="card card-hover-grow" [ngClass]="{ 'custom-card': plan.nombre == 'Plan Premium' }">
                @if (plan.nombre == 'Plan Premium') {
                    <div class="destacado">
                        <div class="box">
                            <i class="fa fa-star fa-lg"></i>
                            <span>
                                Recomendado
                            </span>
                        </div>
                    </div>
                }
                <div class="card-body">
                    <h5 class="card-title">{{ plan.nombre }}</h5>
                    @if (plan.nombre == 'Plan Premium') {
                        <h6 class="card-title-2">
                            VALOR ESTIMADO $1,120.00
                        </h6>
                    }
                    <p class="card-subtitle">{{ plan.descripcion }}</p>
                    <div class="text-center mb-4 mt-3">
                        @if (plan.nombre == 'Plan Premium'){
                            <span class="span-premium">Tu pagas:<strong> ${{ plan.precio }}</strong> al año</span>
                        } @else {
                            <span><strong>${{ plan.precio }}</strong><small>/anual</small></span>
                        }
                    </div>
                    <div class="checklist">
                        <ul *ngFor="let item of plan.beneficios">
                            <li>
                                <div class="check-item">
                                    <img src="assets/images/icons/vector.png" alt="vector" width="20" height="15">
                                    <span>{{ item.nombre_beneficio }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center mt-5 mb-2">
                        <button (click)="planSelected(plan)" class="btn custom-button" [ngClass]="{ 'custom-button-2': plan.id_planes !== 2 }">
                            @if (plan.id_planes == 2) {
                                <span>
                                    Comenzar ahora 
                                </span>
                            } @else {
                                <span>
                                    Seleccionar plan    
                                </span>
                            }
                        </button>
                    </div>
                    <div class="text-center mb-5">
                        @if (plan.id_planes == 2) {
                            <small>El plan más popular entre nuestros usuario</small>
                        }
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div id="carouselPlanesIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-interval="10000">
            <div class="carousel-indicators">
                <button 
                    *ngFor="let plan of planes; let i = index"
                    type="button"
                    data-bs-target="#carouselPlanesIndicators"
                    [attr.data-bs-slide-to]="i"
                    [class.active]="i === 1" 
                    aria-current="i === 1 ? 'true' : null" 
                    [attr.aria-label]="'Slide ' + (i + 1)">
                </button>
            </div>
            <div class="carousel-inner" #plan>
                <div *ngFor="let plan of planes; let i = index" class="carousel-item" [class.active]="i === 1">
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center">
                            <div class="card card-hover-grow" [ngClass]="{ 'custom-card': i === 1 }">
                                @if (plan.id_planes == 2) {
                                    <div class="destacado">
                                        <div class="box">
                                            <i class="fa fa-star fa-lg"></i>
                                            <span>
                                                Recomendado
                                            </span>
                                        </div>
                                    </div>
                                }
                                <div class="card-body">
                                    <h5 class="card-title">{{ plan.nombre }}</h5>
                                    <p class="card-subtitle">{{ plan.descripcion }}</p>
                                    <div class="text-center mb-4 mt-3">
                                        <span><strong>${{ plan.precio }}</strong><small>/anual</small></span>
                                    </div>
                                    <div class="checklist">
                                        <ul *ngFor="let item of plan.beneficios">
                                            <li>
                                                <div class="check-item">
                                                    <img src="assets/images/icons/vector.png" alt="vector" width="20" height="15">
                                                    <span>{{ item.nombre_beneficio }}</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="d-flex justify-content-center mt-5 mb-2">
                                        <button (click)="planSelected(plan)" class="btn custom-button" [ngClass]="{ 'custom-button-2': plan.id_planes !== 2 }">
                                            @if (plan.id_planes == 2) {
                                                <span>
                                                    Comenzar ahora 
                                                </span>
                                            } @else {
                                                <span>
                                                    Seleccionar plan    
                                                </span>
                                            }
                                        </button>
                                    </div>
                                    <div class="text-center mb-5">
                                        @if (plan.nombre == 'Plan Premium') {
                                            <small>El plan más popular entre nuestros usuario</small>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

</div>

<!-- <div class="row">
    <div class="container-title">
        <h2>Elige el plan perfecto para tu futuro financiero</h2>
        <p class="description">Selecciona el plan que mejor se adapte a tus objetivos de inversión y comienza a construir tu patrimonio hoy mismo</p>
    </div>
</div>

<div class="row mb-5">
    @if (isMediumScreen == false) {
        <div *ngFor="let plan of planes; let i = index" class="col-lg-4" #plan >
            <div class="card card-hover-grow" [ngClass]="{ 'custom-card': i === 1 }">
                @if (plan.title == 'Plan Premium') {
                    <div class="destacado">
                        <div class="box">
                            <i class="fa fa-star fa-lg"></i>
                            <span>
                                Recomendado
                            </span>
                        </div>
                    </div>
                }
                <div class="card-body">
                    <h5 class="card-title">{{ plan.title }}</h5>
                    <p class="card-subtitle">{{ plan.description }}</p>
                    <div class="text-center mb-4 mt-3">
                        <span><strong>${{ plan.price }}</strong><small>/anual</small></span>
                    </div>
                    <div class="checklist">
                        <ul *ngFor="let item of plan.items">
                            <li>
                                <div class="check-item">
                                    <img src="assets/images/icons/vector.png" alt="vector" width="20" height="15">
                                    <span>{{ item }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center mt-5 mb-2">
                        <a [href]="plan.link" target="_blank" class="btn custom-button" [ngClass]="{ 'custom-button-2': i !== 1 }">
                        @if (plan.title == 'Plan Premium') {
                            <span>
                                Comenzar ahora 
                            </span>
                        } @else {
                            <span>
                                Seleccionar plan    
                            </span>
                        }
                        </a>
                    </div>
                    <div class="text-center mb-5">
                        @if (plan.title == 'Plan Premium') {
                            <small>El plan más popular entre nuestros usuario</small>
                        }
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div id="carouselPlanesIndicators" class="carousel slide" data-bs-ride="carousel" data-bs-interval="10000">
            <div class="carousel-indicators">
                <button 
                    *ngFor="let plan of planes; let i = index"
                    type="button"
                    data-bs-target="#carouselPlanesIndicators"
                    [attr.data-bs-slide-to]="i"
                    [class.active]="i === 1" 
                    aria-current="i === 1 ? 'true' : null" 
                    [attr.aria-label]="'Slide ' + (i + 1)">
                </button>
            </div>
            <div class="carousel-inner" #plan>
                <div *ngFor="let plan of planes; let i = index" class="carousel-item" [class.active]="i === 1">
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center">
                            <div class="card card-hover-grow" [ngClass]="{ 'custom-card': i === 1 }">
                                @if (plan.title == 'Plan Premium') {
                                    <div class="destacado">
                                        <div class="box">
                                            <i class="fa fa-star fa-lg"></i>
                                            <span>
                                                Recomendado
                                            </span>
                                        </div>
                                    </div>
                                }
                                <div class="card-body">
                                    <h5 class="card-title">{{ plan.title }}</h5>
                                    <p class="card-subtitle">{{ plan.description }}</p>
                                    <div class="text-center mb-4 mt-3">
                                        <span><strong>${{ plan.price }}</strong><small>/anual</small></span>
                                    </div>
                                    <div class="checklist">
                                        <ul *ngFor="let item of plan.items">
                                            <li>
                                                <div class="check-item">
                                                    <img src="assets/images/icons/vector.png" alt="vector" width="20" height="15">
                                                    <span>{{ item }}</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="d-flex justify-content-center mt-5 mb-2">
                                        <a [href]="plan.link" target="_blank" class="btn custom-button" [ngClass]="{ 'custom-button-2': i !== 1 }">
                                        @if (plan.title == 'Plan Premium') {
                                            <span>
                                                Comenzar ahora 
                                            </span>
                                        } @else {
                                            <span>
                                                Seleccionar plan    
                                            </span>
                                        }
                                        </a>
                                    </div>
                                    <div class="text-center mb-5">
                                        @if (plan.title == 'Plan Premium') {
                                            <small>El plan más popular entre nuestros usuario</small>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

</div> -->